.SwitchLabel {
  place-self: end;
  user-select: none;
  cursor: pointer;
  position: relative;
  display: inline-grid;
  grid: auto / auto auto;
  gap: var(--space-xs);
  border-radius: var(--radius-sm);
  color: var(--neutral);
  font-size: 0.8125rem;
  transition: color 250ms;

  [type="checkbox"] {
    position: absolute;
    opacity: 0;
    width: 0;
    height: 0;
    pointer-events: none;
  }

  &:has(:checked) .SwitchLabelText {
    color: var(--primary);
  }

  :has([type="checkbox"]:focus-visible) {
    outline: 2px solid var(--focus);
    outline-offset: 2px;
  }

  &:has([data-read-only="true"]) {
    pointer-events: none;
    cursor: default;
    opacity: 0.6;
  }
}

.SwitchTrack {
  display: block;
  height: 1rem;
  aspect-ratio: 2/1;
  border-radius: var(--radius-sm);
  background: var(--neutral-1);
  transition: background 150ms;
  &:after {
    display: inherit;
    border-radius: inherit;
    margin: 2px;
    height: 11px;
    width: 11px;
    content: "";
    background: var(--white);
    transition: transform 250ms;
  }

  &:has(:checked) {
    background: var(--primary);
    &:after {
      transform: translateX(calc(100% + 4px));
    }
  }
}
